import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, unBindCard, verifyPassword } from './modules'
import { removeSalt } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const Main = Loadable({
    loader: () => import('./Main'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          bankCardMainState: state.bankCardMainState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          unBindCard,
          verifyPassword,
          removeSalt,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/main`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Main {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
